import { gray } from '@synoptic/ui-kit/palette.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { ellipsis } from '@synoptic/ui-kit/utility.css.js';
import { style } from '@vanilla-extract/css';

export const userContainer = style({
  display: 'flex',
  gap: space.s12,
  minWidth: 0,
});
export const userAvatar = style({
  flexShrink: 0,
});
export const userInfo = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s2,
  overflow: 'hidden',
});
export const userName = style([
  typography['labelMd'],
  ellipsis,
  {
    color: themeVars.container.foreground.primary,
  },
]);
export const userNameInversed = style({
  color: gray[50],
});

export const userNameUnderline = style({
  ':hover': {
    textDecoration: 'underline',
  },
});
export const userHandle = style([
  typography['labelSm'],
  {
    color: themeVars.container.foreground.secondary,
  },
  ellipsis,
]);
export const userHandleInversed = style({
  color: gray[400],
});
